import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const ShopContext = createContext(null);

export function ShopProvider({ children }) {
  const { user } = useAuth();
  const [shops, setShops] = useState([]);
  const [currentShopId, setCurrentShopId] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadShops = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/shops");
      setShops(data);
      setCurrentShopId((prev) => prev || (data[0] ? data[0].id : null));
    } catch (e) {
      setShops([]);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    loadShops();
  }, [loadShops]);

  const currentShop = shops.find((s) => s.id === currentShopId) || null;

  return (
    <ShopContext.Provider value={{ shops, currentShop, currentShopId, setCurrentShopId, loading, reloadShops: loadShops }}>
      {children}
    </ShopContext.Provider>
  );
}

export function useShop() {
  return useContext(ShopContext);
}
